// Auto-split from i18n.js — language: pt
export default {
    translation: {
        // routes & menus
        Dashboard: 'Painel de instrumentos',
        'Space Data': 'Espaço',
        'Equipment Data': 'Equipamentos',
        'Meter Data': 'Medidor',
        'Tenant Data': 'Inquilino',
        'Store Data': 'Loja',
        'Shopfloor Data': 'Chão de fábrica',
        'Combined Equipment Data': 'Equipamento Combinado',
        'Auxiliary System': 'Sistema Auxiliar',
        Microgrid: 'Microgrelha',
        'Energy Storage Power Station': 'Central eléctrica',
        'Photovoltaic Power Station': 'Central eléctrica',
        'Fault Alarm': 'Alarme de falha',
        Monitoring: 'Monitoramento',
        'Advanced Reporting': 'Relatórios Avançados',
        'Knowledge Base': 'Base de Conhecimento',
        'Energy Category Data': 'Categoria energética',
        'Energy Item Data': 'Item de energia',
        Carbon: 'Emissões de CO2',
        Cost: 'Custo',
        Output: 'Saída',
        Income: 'Rendimentos',
        Efficiency: 'Eficiência',
        Load: 'Carregar',
        Statistics: 'Estatísticas',
        'Batch Analysis': 'Análise em Lote',
        Saving: 'PoupançaⒺ',
        Plan: 'PlanejamentoⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Produção',
        'Space Production': 'Produção Espacial',
        'Equipment Tracking': 'Rastreamento do equipamento',
        'Equipment Comparison': 'Comparação de equipamentos',
        'Shopfloor Comparison': 'Comparação de equipamentos',
        'Store Comparison': 'Comparação de equipamentos',
        'Combined Equipment Comparison': 'Comparação de equipamentos',
        'Tenant Comparison': 'comparação de inquilinos',
        'Environment Monitor': 'Monitor Ambiente',
        'Meter Energy': 'Energia do medidor',
        'Meter Prediction': 'Previsão do medidorⒺ',
        'Virtual Meter Prediction': 'Previsão do medidor virtualⒺ',
        'Offline Meter Prediction': 'Previsão do medidor offlineⒺ',
        'Meter Carbon': 'Medidor de emissões de CO2',
        'Meter Cost': 'Custo do medidor',
        'Meter Trend': 'Tendência do medidor',
        'Meter Realtime': 'Medidor em Tempo Real',
        'Meter Saving': 'Economia do medidorⒺ',
        'Meter Plan': 'Plano do medidorⒺ',
        'Master Meter Submeters Balance': 'Master Metro Submeters Equilíbrio',
        'Meter Batch Analysis': 'Análise de lotes de medidores',
        'Meter Comparison': 'Comparação do medidor',
        'Meter Tracking': 'Rastreamento do medidor',
        'Virtual Meter Saving': 'Poupança do medidor virtualⒺ',
        'Virtual Meter Plan': 'Plano do medidor virtualⒺ',
        'Virtual Meter Energy': 'Energia do medidor virtual',
        'Virtual Meter Carbon': 'Emissões de CO2 do medidor virtual',
        'Virtual Meter Cost': 'Custo do medidor virtual',
        'Virtual Meter Batch Analysis': 'Análise de lotes de medidores virtuais',
        'Virtual Meter Comparison': 'Comparação de Medidores Virtuais',
        'Offline Meter Energy': 'Energia do medidor offline',
        'Offline Meter Carbon': 'Medidor off-line Emissões de CO2',
        'Offline Meter Cost': 'Custo do medidor offline',
        'Offline Meter Batch Analysis': 'Análise de lotes de medidores offline',
        'Offline Meter Saving': 'Economia do medidor offlineⒺ',
        'Offline Meter Plan': 'Plano do medidor offlineⒺ',
        'Offline Meter Input': 'Entrada do medidor offline',
        'Tenant Bill': 'Lei do inquilino',
        'Energy Flow Diagram': 'Diagrama de fluxo de energia',
        'Distribution System': 'Sistema de distribuição',
        'SVG System': 'Sistema de Visualização SCADA',
        'Faults Data': 'Defeitos',
        'Space Equipments': 'equipamentos espaciais',
        'Combined Equipments': 'Equipamentos combinados',
        'Energy Storage Power Station List': 'Lista',
        'Energy Storage Power Station Details': 'Detalhes',
        'Energy Storage Power Station Reporting': 'Relatórios',
        'Energy Storage Power Station Alarm': 'Alarme',
        'Energy Storage Power Station Maintenance': 'Manutenção',
        'Enter Production': 'Entrar Produção',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Várias estações elétricas',
        'Multiple Energy Storage Power Stations Dashboard': 'Painel',
        'Multiple Energy Storage Power Stations List': 'Lista',
        'Single Energy Storage Power Station': 'Estação elétrica única',
        'Single Energy Storage Power Station Dashboard': 'Painel',
        'Single Energy Storage Power Station Details': 'Detalhes',
        'Single Energy Storage Power Station Fault Alarm': 'Alarme de falha',
        'Energy Storage Power Station Reports': 'Relatórios da Estação de Energia',
        'Energy Storage Power Station Reports Energy': 'Energia',
        'Energy Storage Power Station Reports Revenue': 'Receita',
        'Energy Storage Power Station Reports Parameters': 'Parâmetros',
        'Photovoltaic Power Station List': 'Lista de Estações de Energia',
        'Photovoltaic Power Station Details': 'Detalhes',
        'Photovoltaic Power Station Reporting': 'Relatórios',
        'Photovoltaic Power Station Alarm': 'Alarme',
        'Photovoltaic Power Station Maintenance': 'Manutenção',
        'Multiple Photovoltaic Power Stations': 'Várias estações elétricas',
        'Multiple Photovoltaic Power Stations Dashboard': 'Painel',
        'Multiple Photovoltaic Power Stations List': 'Lista',
        'Single Photovoltaic Power Station': 'Estação elétrica única',
        'Single Photovoltaic Power Station Dashboard': 'Painel',
        'Single Photovoltaic Power Station Details': 'Detalhes',
        'Single Photovoltaic Power Station Fault Alarm': 'Alarme de falha',
        'Photovoltaic Power Station Reports': 'Relatórios da Estação de Energia',
        'Photovoltaic Power Station Reports Energy': 'Energia',
        'Photovoltaic Power Station Reports Revenue': 'Receita',
        'Photovoltaic Power Station Reports Parameters': 'Parâmetros',
        'Work Order': 'Ordem de trabalho',
        'Work Order Installation': 'Instalação',
        'Work Order Repair': 'Reparação',
        'Work Order Inspection': 'Inspeção',
        'Total Number of Work Orders': 'Número total de encomendas de trabalho',
        'Number of New Work Orders': 'Número de novos pedidos de trabalho',
        'Number of Inprogress Work Orders': 'Número de pedidos de trabalho em curso',
        'Number of Done Work Orders': 'Número de pedidos de trabalho realizados',
        'Fuel Indicator': 'Consumo de combustível',
        'Charge Energy Indicator': 'Energia de carga',
        'Discharge Energy Indicator': 'Energia de descarga',
        'Charge Cost Indicator': 'Custo de cobrança',
        'Discharge Revenue Indicator': 'Receitas de quitação',
        'HVAC': 'HVAC',
        'Fire Control': 'Controle Incêndio',
        'Store Dashboard': 'Painel de Lojas',
        'Comprehensive overview of store energy performance': 'Visão abrangente do desempenho energético das lojas',
        'Total Stores': 'Total de Lojas',
        'Total Area': 'Área Total',
        'Active Meters': 'Medidores Ativos',
        'Active Alerts': 'Alertas Ativos',
        'Total Energy Consumption': 'Consumo Total de Energia',
        'Total Cost': 'Custo Total',
        'Carbon Emissions': 'Emissões de Carbono',
        'Current Period': 'Período Atual',
        'Energy Consumption by Category': 'Consumo de Energia por Categoria',
        'Cost Distribution by Category': 'Distribuição de Custos por Categoria',
        'Monthly Energy & Cost Trends': 'Tendências Mensais de Energia e Custos',
        'Top 5 Energy Consuming Stores': 'Top 5 Lojas com Maior Consumo de Energia',
        'Energy Category Details': 'Detalhes das Categorias de Energia',
        'Store Performance Overview': 'Visão Geral do Desempenho das Lojas',
        'YoY Change': 'Variação Anual',
        'Per m²': 'Por m²',
        'Usage Intensity': 'Intensidade de Uso',
        'Dashboard data loaded successfully': 'Dados do painel carregados com sucesso',
        'Failed to load dashboard data': 'Falha ao carregar dados do painel',
        'Store Name': 'Nome da Loja',
        'Store Area': 'Área da Loja',
        'Energy Consumption': 'Consumo de Energia',
        'Consumption': 'Consumo',
        'last period': 'período anterior',
        // Tenant Dashboard
        'Tenant Dashboard': 'Painel de Inquilinos',
        'Comprehensive overview of tenant energy performance': 'Visão abrangente do desempenho energético dos inquilinos',
        'Total Tenants': 'Total de Inquilinos',
        'Tenant Performance Overview': 'Visão Geral do Desempenho dos Inquilinos',
        'Tenant Name': 'Nome do Inquilino',
        'Tenant Area': 'Área do Inquilino',
        'Tenant Type': 'Tipo de Inquilino',
        // Equipment Dashboard
        'Equipment Dashboard': 'Painel de Equipamentos',
        'Total Equipments': 'Total de Equipamentos',
        'Equipment Performance Overview': 'Visão Geral do Desempenho dos Equipamentos',
        'Equipment Name': 'Nome do Equipamento',
        'Equipment Type': 'Tipo de Equipamento',
        'Total Energy': 'Energia Total',
        'Total Sensors': 'Total de Sensores',
        'Increment Rate': 'Taxa de Incremento',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Total de oficinas',
        'Shopfloor Performance Overview': 'Visão geral do desempenho das oficinas',
        'Shopfloor Name': 'Nome da oficina',
        'Shopfloor Area': 'Área da oficina',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Total de Equipamentos Combinados',
        'Combined Equipment Performance Overview': 'Visão Geral do Desempenho dos Equipamentos Combinados',
        'Combined Equipment Name': 'Nome do Equipamento Combinado',
        'Associated Equipments': 'Equipamentos Associados',

            // Dashboard
            'Welcome to QiXuan': 'Bem-vindo ao QiXuan',
            'An Industry Leading Energy Management System':
                'Um sistema de gerenciamento de energia de código aberto líder da indústria',
            "This Year's Consumption CATEGORY VALUE UNIT": "O consumo deste ano {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Year's Costs CATEGORY VALUE UNIT": "Custos deste ano {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Consumption CATEGORY VALUE UNIT": "Este mês Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
            "This Month's Costs CATEGORY VALUE UNIT": "Custos deste mês {{CATEGORY}} {{VALUE}} {{UNIT}}",
            'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
                'Consumo {{CATEGORY}} {{VALUE}} {{UNIT}} No mesmo período do ano passado',
            'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
                'Custos {{CATEGORY}} {{VALUE}} {{UNIT}} No mesmo período do ano passado',
            'CATEGORY Consumption UNIT': '{{CATEGORY}} Consumo {{UNIT}}',
            'CATEGORY Costs UNIT': '{{CATEGORY}} Custos {{UNIT}}',
            // Entities
            Space: 'Espaço',
            Equipment: 'Equipamento',
            Meter: 'medidor',
            'Offline Meter': 'medidor offline',
            'Virtual Meter': 'Medidor virtual',
            Tenant: 'Locatário',
            Store: 'Loja',
            Shopfloor: 'Shopfloor',
            'Combined Equipment': 'Equipamento combinado',
            'Cost Center': 'Centro Custo',
            Name: 'Nome',
            DisplayName: 'Mostrar o Nome',
            UserName: 'Nome do usuário',
            Description: 'Descrição',
            'Energy Category': 'Categoria de energia',
            'Child Spaces': 'Espaços para crianças',
            'Associated Equipment': 'Equipamento associado',
            //Energy Categories
            Electricity: 'eletricidade',
            Water: 'Água',
            'Natural Gas': 'gás natural',
            // SidePanelModal
            Settings: 'Configuração',
            'Set your own customized style': 'Defina seu próprio estilo personalizado',
            'Color Scheme': 'Esquema de cores',
            'Choose the perfect color mode for your app': 'Escolha o modo de cor perfeito para o seu aplicativo',
            Light: 'Luz',
            Dark: 'Escuro',
            'RTL Mode': 'Modo RTL',
            'Switch your language direction': 'Mude de direção de idioma',
            'Fluid Layout': 'Layout de fluido',
            'Toggle container layout system': 'Alternar o sistema de layout do contêiner',
            'Navigation Position': 'Posição de Navegação',
            'Vertical': 'Vertical',
            'Top': 'Topo',
            'Combo': 'Combinação',
            'Transparent': 'Transparente',
            'Inverted': 'Invertido',
            'Card': 'Cartão',
            'Vibrant': 'Vivo',
            'Select a suitable navigation system for your web application':
                'Selecione um sistema de navegação adequado para sua aplicação web',
            'Vertical Nav': 'Navegação Vertical',
            'Top Nav': 'Navegação superior',
            'Vertical Navbar Style': 'Estilo Navbar Vertical',
            'Switch between styles for your vertical navbar': 'Alternar entre estilos para sua barra de navegação vertical',
            Language: 'Idioma',
            'Switch between languages': 'Alternar entre idiomas',
            'language-zh_CN': '简体中文',
            'language-en': 'English',
            'language-de': 'Deutsch',
            'language-fr': 'Français',
            'language-es': 'Español',
            'language-ru': 'Русский',
            'language-ar': 'العربية',
            'language-vi': 'Tiếng Việt',
            'language-th': 'ภาษาไทย',
            'language-tr': 'Türkçe',
            'language-ms': 'Bahasa Melayu',
            'language-id': 'Bahasa Indonesia',
            'language-zh_TW': '繁體中文',
            'language-pt': 'Português',
            'language-ko_KR': '로그아웃',
            'language-it': 'Italiano',
            'language-pol': 'Polski',
            'language-nl': 'Nederlands',
            'language-jp': '日本語',
            'language-fa': 'فارسی',
            'Like What You See?': 'Gosto do que você vê?',
            'Get QiXuan now': 'Obtenha QiXuan agora',
            Purchase: 'Edição Enterprise',
            ContactInfo: 'Informacoes de Contato',
            ProductWebsite: 'Site do Produto',
            CompanyWebsite: 'Site da Empresa',
            SalesPhone: 'Telefone de Vendas',
            // Query Panel
            'Base Period Begins': 'Período de base começa',
            'Base Period Ends': 'Período de base termina',
            'Comparison Types': 'Tipos de comparação',
            'Year-Over-Year': 'Ano após ano',
            'Month-On-Month': 'Mês-a-Mês',
            'Free Comparison': 'Comparação Livre',
            'None Comparison': 'Nenhuma comparação',
            'Reporting Period Begins': 'Periodo de relatório começa',
            'Reporting Period Ends': 'Fim do Período de Relatório',
            '(Optional)': '(Opcional)',
            'Period Types': 'Tipos de Período',
            Yearly: 'Anualmente',
            Monthly: 'Mensal',
            Weekly: 'Semanalmente',
            Daily: 'Diário',
            Hourly: 'Horário',
            Submit: 'Enviar',
            'Input Energy Category': 'Categoria de energia de entrada',
            'Output Energy Category': 'Categoria de energia de saída',
            'Fraction Parameter': 'Parâmetro da fração',
            Search: 'Pesquisar',
            //DateRangePicker
            sunday: 'Dom',
            monday: 'Seg',
            tuesday: 'Ter',
            wednesday: 'Qua',
            thursday: 'Qui',
            friday: 'Sex',
            saturday: 'Sáb',
            ok: 'OK',
            today: 'Hoje',
            yesterday: 'Ontem',
            hours: 'Horário',
            minutes: 'minutos',
            seconds: 'segundos',
            last7Days: 'Últimos 7 Dias',
            tomorrow: 'Amanhã',
            dayAfterTomorrow: 'Depois de amanhã',
            next7Days: 'Próximos 7 dias',
            'Select Date Range': 'Selecionar intervalo de data',
            //Card Summaries and Line Charts
            'Base Period': 'Período de base',
            'Reporting Period': 'Período de reporte',
            'Per Unit Area': 'Por Área Unidade',
            'Per Capita': 'Por Capita',
            'Per Unit Production': 'Produção por unidade',
            Baseline: 'Linha de base',
            Actual: 'Atuais',
            'Baseline Value - Actual Value': 'Linha de base - Atual',
            'Average Load': 'Carga média',
            'Maximum Load': 'Carga máxima',
            'Load Factor': 'Fator de carga',
            'Ratio of Average Load to Maximum Load': 'Relação de carga média para carga máxima',
            'Carbon Dioxide Emissions by Energy Category': 'Emissões de dióxido de carbono por categoria de energia',
            'Costs by Energy Category': 'Custos por categoria de energia',
            'Incomes by Energy Category': 'Rendimentos por categoria de energia',
            'Electricity Consumption by Time-Of-Use': 'Consumo de eletricidade por tempo de uso',
            'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Electricidade Emissões de dióxido de carbono por tempo de utilização',
            'Electricity Cost by Time-Of-Use': 'Custo da eletricidade por tempo de uso',
            'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Consumo por Itens Energéticos',
            'Ton of Standard Coal by Energy Category': 'Tonelada de carvão normal(TCE) por categoria de energia',
            'Ton of Carbon Dioxide Emissions by Energy Category': 'Tonelada de Emissões de Dióxido de Carbono (TCO2E) por Categoria de Energia',
            'Reporting Period Consumption CATEGORY UNIT': 'Consumo do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{EQUIPMENT}} Consumo do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Consumo do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption CATEGORY VALUE UNIT': 'Consumo do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Production PRODUCT VALUE UNIT': 'Produção do período de relatório {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Production PRODUCT VALUE UNIT': 'Produção do Período Base {{PRODUCT}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption CATEGORY VALUE UNIT': 'Consumo do Período Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY UNIT': 'Consumo do Período de Relatório {{ITEM}} {{CATEGORY}} {{UNIT}}',
            'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
                'Consumo do Período de Relatório {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Consumption ITEM CATEGORY VALUE UNIT':
                'Consumo do Período Base {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Child Space Proportion CATEGORY UNIT': 'Proporção de espaço infantil por categoria de energia {{CATEGORY}} {{UNIT}}',
            'Child Space Total Proportion': 'Proporção total de espaço infantil',
            'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
                'Emissões de dióxido de carbono no período de relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Emissões de dióxido de carbono no período de relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
                'Emissões de dióxido de carbono no período de base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Costs CATEGORY UNIT': 'Custos do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Costs CATEGORY VALUE UNIT': 'Custos do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Costs CATEGORY VALUE UNIT': 'Custos do período de base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Output CATEGORY UNIT': 'Saída do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Saída do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
                '{{COMBINED_EQUIPMENT}} Saída do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Output CATEGORY VALUE UNIT': 'Saída do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Output CATEGORY VALUE UNIT': 'Produção do período de base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Income CATEGORY UNIT': 'Rendimento do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Income CATEGORY VALUE UNIT': 'Rendimento do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Income CATEGORY VALUE UNIT': 'Rendimento do Período Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Total Income UNIT': 'Período de reporte Total do rendimento {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME UNIT': 'Eficiência Cumulativa do Período de Relatório {{NAME}} {{UNIT}}',
            'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
                '{{EQUIPMENT}} Eficiência Cumulativa do Período de Relatório {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Eficiência global cumulativa do período de relatório {{UNIT}}',
            'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Eficiência global cumulativa do período de relatório {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
                '{{COMBINED_EQUIPMENT}} Eficiência completa cumulativa do período de base {{VALUE}} {{UNIT}}',
            'Instantaneous Efficiency UNIT': 'Eficiência Instantânea {{UNIT}}',
            'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Eficiência Instantânea {{UNIT}}',
            'Equipment Efficiency Indicator': 'Indicador de Eficiência Energética do Equipamento',
            'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
                '{{COMBINED_EQUIPMENT}} Eficiência abrangente instantânea {{UNIT}}',
            'Reporting Period Cumulative Efficiency VALUE UNIT': 'Eficiência Cumulativa do Período de Relatório {{VALUE}} {{UNIT}}',
            'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
                'Eficiência Cumulativa do Período de Relatório {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency VALUE UNIT': 'Eficiência Cumulativa do Período Base {{VALUE}} {{UNIT}}',
            'Base Period Cumulative Efficiency NAME VALUE UNIT':
                'Eficiência Cumulativa do Período Base {{NAME}} {{VALUE}} {{UNIT}}',
            'Base Period CATEGORY Maximum Load UNIT': 'Período de base {{CATEGORY}} Carga máxima {{UNIT}}',
            'Reporting Period CATEGORY Maximum Load UNIT': 'Período de reporte {{CATEGORY}} Carga máxima {{UNIT}}',
            'Reporting Period CATEGORY Average Load UNIT': 'Período de reporte {{CATEGORY}} Carga média {{UNIT}}',
            'Reporting Period CATEGORY Load Factor': 'Período de reporte {{CATEGORY}} Fator de carga',
            'Base Period CATEGORY Average Load VALUE UNIT': 'Período de base {{CATEGORY}} Carga média {{VALUE}} {{UNIT}}',
            'Reporting Period CATEGORY Average UNIT': 'Período de reporte {{CATEGORY}} Valor médio {{UNIT}}',
            'Reporting Period CATEGORY Maximum UNIT': 'Período de reporte {{CATEGORY}} Valor máximo {{UNIT}}',
            'Reporting Period CATEGORY Minimum UNIT': 'Período de reporte {{CATEGORY}} Valor mínimo {{UNIT}}',
            'Reporting Period CATEGORY Mean UNIT': 'Período de reporte {{CATEGORY}} média aritmética {{UNIT}}',
            'Reporting Period CATEGORY Median UNIT': 'Período de reporte {{CATEGORY}} Mediana (valor médio) {{UNIT}}',
            'Reporting Period CATEGORY Stdev UNIT': 'Período de reporte {{CATEGORY}} Desvio padrão da amostra {{UNIT}}',
            'Reporting Period CATEGORY Variance UNIT': 'Período de reporte {{CATEGORY}} Variância da amostra {{UNIT}}',
            'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
                'Economia do período de relatório {{CATEGORY}} (Linha de base - Atual) {{UNIT}}',
            'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
                'Período de relatório diminuído {{CATEGORY}} (Linha de base - Atual) {{UNIT}}',
            'Reporting Period Saving CATEGORY VALUE UNIT': 'Economia do período de relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Base Period Saving CATEGORY VALUE UNIT': 'Economia do Período Base {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY UNIT':
                'Consumo do medidor mestre do período de relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
                'Consumo do medidor mestre do período de relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY UNIT':
                'Período de Relatório Submetros Consumo {{CATEGORY}} {{UNIT}}',
            'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
                'Período de Relatório Submetros Consumo {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Reporting Period Difference CATEGORY UNIT': 'Diferença do Período de Relatório {{CATEGORY}} {{UNIT}}',
            'Reporting Period Percentage Difference': 'Período de relatório Diferença percentual',
            'Reporting Period Difference CATEGORY VALUE UNIT': 'Diferença do Período de Relatório {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'Trend Values': 'Valores de tendência',
            'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
            //FDD
            'Fault List': 'Lista de falhas',
            'Reporting Period Number of Fault VALUE': 'Período de relatório Número de falhas {{VALUE}}',
            'All Faults': 'Todas as falhas',
            'Space Faults': 'Falhas espaciais',
            'Number of All Faults': 'Número de todas as falhas',
            'Number of Space Faults': 'Número de falhas espaciais',
            'Total Number of Faults': 'Número total de falhas',
            'Number of New Faults': 'Número de novas falhas',
            'Number of Inprogress Faults': 'Número de falhas em curso',
            'Number of Done Faults': 'Número de falhas feitas',
            //Data Panels
            'Ton of Standard Coal': 'Tonelada de carvão normal',
            'Ton of Carbon Dioxide Emissions': 'Toneladas de emissões de dióxido de carbono',
            'Carbon Emissions Per Unit Of Energy Consumption': 'Emissões de carbono por unidade de consumo de energia',
            'Operating Characteristic Curve': 'Curva característica operacional',
            Tariff: 'Tarifa',
            'Detailed Data': 'Dados detalhados',
            'Child Spaces Data': 'Dados de espaços infantis',
            'Associated Equipment Data': 'Dados de equipamentos associados',
            'This Year': 'Este ano',
            'The Same Period Last Year': 'O mesmo período do ano passado',
            'This Month': 'Este mês',
            'This Day': 'Este dia',
            Total: 'Total',
            'No data found': 'Não foram encontrados dados',
            Export: 'Exportação',
            'AI Analysis': 'Análise por IA',
            Datetime: 'Data e hora',
            'Time-Of-Use Type': 'Tipo de tempo de uso',
            'Top-Peak': 'Top-pico',
            'On-Peak': 'No pico',
            'Mid-Peak': 'Meio-pico',
            'Off-Peak': 'Off-pico',
            'Deep': 'Deep-Valley',
            Percentage: 'Percentagem',
            //Realtime Chart
            'Trend in the last hour of Energy Value Point': 'Tendência na última hora de Energy Value Point',
            Circuit: 'Circuito',
            Point: 'Ponto',
            'Realtime Value': 'Valor em tempo real',
            //Meter Tracking
            'Meter List': 'Lista do medidor',
            'Edit Meter': 'Editar',
            'Start Value': 'Valor inicial',
            'End Value': 'Valor Final',
            'Difference Value': 'Valor da Diferença',
            'Start Integrity Rate': 'Taxa de Integridade Inicial(%)',
            'End Integrity Rate': 'Taxa de integridade final(%)',
            'Full Integrity Rate': 'Taxa de Integridade Total(%)',
            'Start Integrity Rate Description': 'Taxa de Integridade de Dados Inicial: Proporção de medidores que obtiveram com sucesso leituras de consumo de energia no horário de início entre todos os medidores durante o período estatístico',
            'End Integrity Rate Description': 'Taxa de Integridade de Dados Final: Proporção de medidores que obtiveram com sucesso leituras de consumo de energia no horário de término entre todos os medidores durante o período estatístico',
            'Full Integrity Rate Description': 'Taxa de Integridade de Dados Completa: Proporção de medidores que obtiveram com sucesso leituras de consumo de energia nos horários de início e término entre todos os medidores durante o período estatístico',
            //Equipment Tracking
            'Equipment List': 'Lista de equipamentos',
            'Edit Equipment': 'Editar',
            //Profile Dropdown
            Feedback: 'Comentários',
            'Account Settings': 'Configurações da Conta',
            Logout: 'Sair',
            //Authentication
            'Log in': 'Entrar',
            'Email address': 'Endereço de e-mail',
            'Phone Number': 'Número de telefone',
            Password: 'Senha',
            CaptchaCode: 'Captcha',
            Refresh: 'Refreshar',
            'Remember me': 'Lembre-se de mim',
            'Logged in as ': 'Login como ',
            'Forgot Password?': 'Esqueci a senha?',
            'Forgot your password?': 'Esqueceu a senha?',
            "Enter your email and we'll send you a reset link": "Digite seu e-mail e nós lhe enviaremos um link de reset",
            "Enter your email and we'll send you a registration link":
                "Digite seu e-mail e enviaremos um link de registro",
            'Reset Password': 'Restaurar senha',
            'Thanks for using QiXuan!': 'Obrigado por usar o QiXuan!',
            'You are now successfully signed out': 'Você saiu com sucesso',
            'Return to Login': 'Voltar para Login',
            'Please check your email!': 'Por favor, verifique seu e-mail!',
            'An email has been sent to ': 'Um e-mail foi enviado para ',
            'Please click on the included link to reset your password':
                'Clique no link incluído para redefinir sua senha',
            'Please click on the included link to register your account':
                'Clique no link incluído para registrar sua conta',
            'An email with password reset link is sent to ': 'Um e-mail com link de redefinição de senha é enviado para ',
            'Change Password': 'Alterar senha',
            'Old Password': 'Senha antiga',
            'New Password': 'Nova senha',
            'Confirm Password': 'Confirmar senha',
            'Update Password': 'Atualizar senha',
            'Password has been changed!': 'A senha foi alterada!',
            'Verification code has been sent to your inbox. \
  Please copy it to the input box below..':
                'Código de verificação foi enviado para a sua caixa de entrada. \
  Por favor, copie-o para a caixa de entrada abaixo.',
            'New to QiXuan': 'Novo no QiXuan',
            'Create an account': 'Criar uma conta',
            'EMAIL Account registration successful': '{{EMAIL}} Registro de conta bem sucedido',
            'Thanks for verifying your account!': 'Obrigado por verificar sua conta!',
            'Your code is': 'Seu código é',
            'Send verification code': 'Enviar código de verificação',
            'Please wait for NUMBER seconds': 'Por favor aguarde {{NUMBER}} segundos',
            'Password reset': 'Reinicializar senha',
            'Please wait for approval': 'Aguarde a aprovação',
            //notification
            Notifications: 'Notificações',
            'Mark all as read': 'Marcar tudo como lido',
            'View all': 'Todos',
            'Notification New': 'NOVO',
            'Notification Earlier': 'MAIS ANTERIOR',
            'Notification List': 'Lista de notificações',
            'Bulk actions': 'Ações em massa',
            'Notification Subject': 'Assunto',
            'Notification Created Datetime': 'Data e hora de criação',
            'Notification Priority': 'Prioridade',
            'Notification Message': 'Mensagem',
            'Notification Status': 'Estado',
            'Notification Mark As Read': 'Marcar como lido',
            'Notification Mark As Acknowledged': 'Reconhecer',
            'Notification Low': 'Baixo',
            'Notification Medium': 'Médio',
            'Notification High': 'Alta',
            'Notification Critical': 'Crítico',
            'Notification Unread': 'Não lido',
            'Notification Read': 'Leia',
            'Notification Acknowledged': 'Reconhecido',
            'Notification Archive': 'Arquivo',
            'Notification Delete': 'Apagar',
            'Notification Apply': 'Aplicar',
            'Notification Start Datetime': 'Data de início e hora',
            'Notification End Datetime': 'Data e hora do fim',
            'Notification Update Datetime': 'Actualizar a Data- Hora',
            //Monitoring
            'Run Commands': 'Executar comandos',
            'Pin Code': 'Código Pin',
            'Unlock': 'Desbloquear',
            'Set Value': 'Definir o Valor',
            'Fault Alarms': 'Alarmes de falha',
            'Instantaneous Efficiency VALUE UNIT': 'Eficiência Instantânea {{VALUE}} {{UNIT}}',
            'Communication Online': 'Online',
            'Communication Offline': 'Offline',
            'Equipment Status': 'Estado do equipamento',
            'Equipment Running': 'Correndo',
            'Equipment Stopped': 'Parado',
            'Show Up to': 'Mostrar até',
            All: 'Todos',
            'FROM - TO of TOTAL': 'A exibição atual de {{FROM}} - {{TO}} total {{TOTAL}}',
            //Microgrid
            'Microgrid Energy': 'Energia de Microrrede',
            'Microgrid Revenue': 'Receita de Microrrede',
            'Microgrid Carbon': 'Carbono de Microrrede',
            'Photovoltaic Generation': 'Geração Fotovoltaica',
            'EV Charger Consumption': 'Consumo de Carregadores EV',
            'Load Consumption': 'Consumo de Carga',
            'Grid Buy': 'Compra da Rede',
            'Grid Sell': 'Venda para a Rede',
            'EV Charger': 'Carregador EV',
            'Heat Pump': 'Bomba de calor',
            'Photovoltaic': 'Fotovoltaica',
            'PCS Run State': 'Estado de execução do PCS',
            'PCS Unknown': 'Desconhecido',
            'PCS Initializing': 'Inicialização',
            'PCS Standby': 'em espera',
            'PCS Shutdown': 'Desligamento',
            'PCS Fault': 'Falha',
            'PCS Running': 'Correndo',
            'Battery Power': 'Energia da bateria',
            'Photovoltaic Power': 'Potência fotovoltaica',
            'Grid Power': 'Potência da Rede',
            'Load Power': 'Potência de carga',
            Reporting: 'Relatórios',
            Maintenance: 'Manutenção',
            'Serial Number': 'Número de série',
            Address: 'Endereço',
            'Postal Code': 'Código Postal',
            'Rated Capacity': 'Capacidade nominal',
            'Rated Power': 'Potência nominal',
            Latitude: 'Latitude',
            Longitude: 'Longitude',
            'Strategy Management': 'Gestão Estratégica',
            'Charging Schedule': 'Horário de carregamento',
            'Charge Start Time': 'Hora de início da carga',
            'Charge End Time': 'Tempo de fim de carga',
            'Discharge Start Time': 'Hora de início da descarga',
            'Discharge End Time': 'Tempo final de descarga',
            'Total Rated Power': 'Potência nominal total',
            'Total Rated Capacity': 'Capacidade nominal total',
            "Today's Charge": "Carga de hoje",
            "Today's Discharge": "Discharge de hoje",
            "Today's Generation": "Geração de hoje",
            'Total Fuel Consumption': 'Total Fuel Consumption',
            'Total Charge': 'Carga Total',
            'Total Discharge': 'Descarga Total',
            'Total Generation': 'Geração Total',
            'Total Revenue': 'Receita Total',
            'Total Photovoltaic Generation': 'Geração Fotovoltaica Total',
            'Total EV Charger Consumption': 'Consumo Total de Carregadores EV',
            'Total Load Consumption': 'Consumo Total de Carga',
            'Total Grid Buy': 'Compra Total da Rede',
            'Total Grid Sell': 'Venda Total para a Rede',
            'Total Efficiency': 'Eficiência Total',
            'Discharge Achievement Rate': 'Taxa de realização da descarga',
            'Revenue Ranking': 'Ranking de receita',
            'Efficiency Ranking': 'Classificação de Eficiência',
            'Charge Ranking': 'Classificação de carga',
            'Discharge Ranking': 'Classificação de descarga',
            'Number of Microgrids': 'Número de microredes',
            'Number of Power Stations': 'Número de estações elétricas',
            'Microgrid List': 'Lista de Microgrelhas',
            'Select Microgrid': 'Selecionar Microgrelha',
            'Previous Page': 'Página anterior',
            'Next Page': 'Página seguinte',
            '7 Days': '7 dias',
            'Charge UNIT': 'Carga {{UNIT}}',
            'Discharge UNIT': 'Descarga {{UNIT}}',
            'Generation UNIT': 'Geração {{UNIT}}',
            'Energy Indicator': 'Energia',
            'Revenue Indicator': 'Receita',
            'Carbon Indicator': 'Carbono',

            // Energy Storage Power Station
            'Battery Operating State': 'Estado de funcionamento da bateria',
            'Battery State': 'Estado da bateria',
            'Battery Unknown': 'Desconhecido',
            'Battery Stopped': 'Parado',
            'Battery Reserved': 'Reservado', // 0
            'Battery Fault': 'Falha', // 1
            'Battery Warning': 'Aviso', // 2
            'Battery Standby': 'em espera', // 3
            'Battery Prohibit DisCharging': 'Proibir Descarga', //4
            'Battery Prohibit Charging': 'Proibir carregamento',// 5
            'Battery Normal': 'Normal', // 6
            'Battery Charging': 'Carregamento', // 7
            'Battery Discharging': 'Descarga', // 8
            'Battery Idle': 'Idle', // 9
            'Phase of Lifecycle': 'Fase do Ciclo de Vida',
            'Use Phase': 'Fase de Utilização',
            'Commissioning Phase': 'Fase de comissionamento',
            'Commissioning Date': 'Commissioning Date',
            'Installation Phase': 'Fase de instalação',
            'Device Status': 'Status do dispositivo',
            'Basic Information': 'Informações básicas',
            'Gateway': 'Portal',
            'Grid Meter': 'Medidor de grade',
            'Load Meter': 'Medidor de carga',
            'ESS Meter': 'ESS Meter',
            'Total Active Power': 'Potência Ativa Total',
            'Active Power A': 'Potência Ativa A',
            'Active Power B': 'Potência Ativa B',
            'Active Power C': 'Potência Ativa C',
            'Total Reactive Power': 'Total Reactive Power',
            'Reactive Power A': 'Potência Reactiva A',
            'Reactive Power B': 'Potência Reactiva B',
            'Reactive Power C': 'Potência Reactiva C',
            'Total Apparent Power': 'Potência aparente total',
            'Apparent Power A': 'Poder aparente A',
            'Apparent Power B': 'Poder aparente B',
            'Apparent Power C': 'Poder aparente C',
            'Total Power Factor': 'Fator de potência total',
            'Active Energy Import': 'Importação de energia ativa',
            'Active Energy Export': 'Exportação de energia ativa',
            'Active Energy Net': 'Rede de Energia Ativa',

            'Generator': 'Generator',

            // Photovoltaic Power Station
            'Invertor': 'Inversor',
            'Invertor Run State': 'Estado de execução do inversor',
            'Invertor Unknown': 'Desconhecido',
            'Invertor Initializing': 'Inicialização',
            'Invertor Standby': 'em espera',
            'Invertor Shutdown': 'Desligamento',
            'Invertor Fault': 'Falha',
            'Invertor Running': 'Correndo',

            //Advanced Reporting & Knowledge base
            'Created Datetime': 'Data e hora de criação',
            'File Format': 'Formato do Arquivo',
            'File Size': 'Tamanho do Arquivo',
            Uploader: 'Carregador',
            //Error
            "The page you're looking for is not found": "A página que você está procurando não foi encontrada.",
            "Make sure the address is correct and that the page hasn't moved. ":
                "Certifique-se de que o endereço está correto e que a página não se mudou. ",
            'If you think this is a mistake,': 'Se você acha que isso é um erro,',
            'contact us': 'entre em contato conosco',
            'Take me home': 'Leve-me para casa.',
            'Whoops, something went wrong!': 'Oups, algo deu errado!',
            'Try refreshing the page, or going back and attempting the action again. ':
                'Tente atualizar a página ou voltar e tentar a ação novamente. ',
            'If this problem persists,': 'Se esse problema persistir,',
            'Captcha Error': 'Erro Captcha',
            'Confirm Password Error': 'A senha de confirmação não corresponde',
            'It looks like you clicked on an invalid password reset link. Please tryagain.':
                'Parece que você clicou \
    em um link de redefinição de senha inválido. Por favor tente novamente.',
            'It looks like you clicked on an invalid registration account link. Please tryagain.':
                'Parece que você clicou \
    em um link de conta de registro inválido. Por favor tente novamente.',
            //Tenant Bill
            'Lease Contract Number': 'Número do contrato de arrendamento',
            Download: 'Transferir',
            Print: 'Imprimir',
            'Payment Notice': 'Aviso de pagamento',
            'Bill To': 'Bill Para',
            'Bill Number': 'Número da conta',
            'Bill Date': 'Data da fatura',
            'Payment Due Date': 'Data de vencimento do pagamento',
            'Amount Payable': 'Montante a pagar',
            'Billing Period Start': 'Inicio do Período de Faturação',
            'Billing Period End': 'Fim do Período de Faturação',
            Quantity: 'Quantidade',
            Price: 'Preço',
            Unit: 'Unidade',
            Amount: 'Quantidade',
            Subtotal: 'Subtotal',
            'VAT Output Tax': 'IVA Imposto sobre a Saída',
            'Total Amount Payable': 'Montante total a pagar',
            'Please make sure to pay on or before the payment due date above':
                'Por favor, certifique-se de pagar no ou antes da data de vencimento acima',
            'Send money to the following account': 'Envie dinheiro para a seguinte conta',
            'Account Name': 'Nome da Conta',
            'Bank Name': 'Nome do Banco',
            'Bank Address': 'Endereço Bancário',
            'RMB Account': 'Conta em RMB',
            // button
            'Toggle Navigation': 'Alternar navegação',
            // working calendar
            'Working Days': 'dias de trabalho',
            'Non Working Days': 'dias não úteis',
            'Select Row': 'Selecione Linha de Dados',
            // Offline Meter Input
            'Daily Value': 'Valor diário',
            Date: 'Data',
            'Successfully Saved': 'Salvado com sucesso',
            'Previous Data Is Empty': 'Dados anteriores estão vazios',
            // API
            'API.ACCOUNT_UNLOCK_FAILED': 'Falha ao desbloquear a conta',
            'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Sessão de administrador não encontrada',
            'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Tempo de sessão do administrador expirado',
            'API.ADVANCED_REPORT_NOT_FOUND': 'Relatório avançado não encontrado',
            'API.API_KEY_HAS_EXPIRED': 'A chave expirou',
            'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'O nome da chave já está em uso',
            'API.API_KEY_NOT_FOUND': 'Chave não encontrada',
            'API.BAD_REQUEST': 'Solicitação inválida',
            'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Ponto de equilíbrio de preço não encontrado',
            'API.BATTERY_STATE_POINT_NOT_FOUND': 'Ponto de estado da bateria não encontrado',
            'API.BUY_METER_NOT_FOUND': 'Medidor de compra não encontrado',
            'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Não é possível definir o submedidor existente como medidor principal',
            'API.CHARGE_METER_NOT_FOUND': 'Medidor de carga não encontrado',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Relação de comando de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de equipamento combinado não encontrada',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Relação de equipamento de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Relação de equipamento de equipamento combinado não encontrada',
            'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Relação de medidor de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relação de medidor de equipamento combinado não encontrada',
            'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'O nome do equipamento combinado já está em uso',
            'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Equipamento combinado não encontrado',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de equipamento combinado não encontrada',
            'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'O nome do parâmetro de equipamento combinado já está em uso',
            'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parâmetro de equipamento combinado não encontrado ou não corresponde',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de equipamento combinado já existe',
            'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de equipamento combinado não encontrada',
            'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'O nome do comando já está em uso',
            'API.COMMAND_NOT_FOUND': 'Comando não encontrado',
            'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'O nome do contato já está em uso',
            'API.CONTACT_NOT_FOUND': 'Contato não encontrado',
            'API.COOLING_METER_NOT_FOUND': 'Medidor de resfriamento não encontrado',
            'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'ID externo do centro de custos já existe',
            'API.COST_CENTER_NAME_EXISTS': 'Nome do centro de custos já existe',
            'API.COST_CENTER_NOT_FOUND': 'Centro de custos não encontrado',
            'API.COST_FILE_NOT_FOUND': 'Arquivo de custos não encontrado',
            'API.DATA_REPAIR_FILE_NOT_FOUND': 'Arquivo de reparo de dados não encontrado',
            'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'O nome da fonte de dados já está em uso',
            'API.DATA_SOURCE_NOT_FOUND': 'Fonte de dados não encontrada',
            'API.DATABASE_ERROR': 'Erro no banco de dados',
            'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Data já está no calendário de trabalho',
            'API.DATE_LOCAL_NOT_FOUND': 'Local da data não encontrado',
            'API.DISCHARGE_METER_NOT_FOUND': 'Medidor de descarga não encontrado',
            'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'O nome do circuito de distribuição já está em uso',
            'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Circuito de distribuição não encontrado',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Relação de ponto de circuito de distribuição já existe',
            'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Relação de ponto de circuito de distribuição não encontrada',
            'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'O nome do sistema de distribuição já está em uso',
            'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Sistema de distribuição não encontrado',
            'API.ELECTRICITY_METER_NOT_FOUND': 'Medidor de eletricidade não encontrado',
            'API.EMAIL_IS_ALREADY_IN_USE': 'E-mail já está em uso',
            'API.EMAIL_MESSAGE_NOT_FOUND': 'Mensagem de e-mail não encontrada',
            'API.EMAIL_NOT_FOUND': 'E-mail não encontrado',
            'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'O host do servidor de e-mail já está em uso',
            'API.EMAIL_SERVER_NOT_FOUND': 'Servidor de e-mail não encontrado',
            'API.EMPTY_VARIABLES_ARRAY': 'Array de variáveis vazio',
            'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'O nome da categoria de energia já está em uso',
            'API.ENERGY_CATEGORY_NOT_FOUND': 'Categoria de energia não encontrada',
            'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Categoria de energia usada em itens de energia',
            'API.ENERGY_CATEGORY_USED_IN_METER': 'Categoria de energia usada em medidor',
            'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Categoria de energia usada em medidor offline',
            'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Categoria de energia usada em tarifas',
            'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Categoria de energia usada em medidor virtual',
            'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'O link do diagrama de fluxo de energia já está em uso',
            'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Link do diagrama de fluxo de energia não encontrado ou não corresponde',
            'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'O nome do diagrama de fluxo de energia já está em uso',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'O nome do nó do diagrama de fluxo de energia já está em uso',
            'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Nó do diagrama de fluxo de energia não encontrado ou não corresponde',
            'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Diagrama de fluxo de energia não encontrado',
            'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Item de energia não pertence à categoria de energia',
            'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Item de energia não pertence à categoria de energia',
            'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'O nome do item de energia já está em uso',
            'API.ENERGY_ITEM_NOT_FOUND': 'Item de energia não encontrado',
            'API.ENERGY_ITEM_USED_IN_METER': 'Item de energia usado em medidor',
            'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Item de energia usado em medidor offline',
            'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Item de energia usado em medidor virtual',
            'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'O nome da estação de armazenamento de energia já está em uso',
            'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Estação de armazenamento de energia não encontrada',
            'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Relação de comando de equipamento já existe',
            'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de equipamento não encontrada',
            'API.EQUIPMENT_METER_RELATION_EXISTS': 'Relação de medidor de equipamento já existe',
            'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Relação de medidor de equipamento não encontrada',
            'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Nome do equipamento já está em uso',
            'API.EQUIPMENT_NOT_FOUND': 'Equipamento não encontrado',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de equipamento já existe',
            'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de equipamento não encontrada',
            'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Nome do parâmetro de equipamento já está em uso',
            'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Parâmetro de equipamento não encontrado ou não corresponde',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de equipamento já existe',
            'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de equipamento não encontrada',
            'API.ERROR': 'Erro',
            'API.EXCEPTION': 'Exceção',
            'API.FAILED_TO_READ_REQUEST_STREAM': 'Falha ao ler o fluxo de solicitação',
            'API.FAILED_TO_RESTORE_COST_FILE': 'Falha ao restaurar o arquivo de custos',
            'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Falha ao restaurar o arquivo de reparo de dados',
            'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Falha ao restaurar o arquivo de conhecimento',
            'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Falha ao restaurar o arquivo de medidor offline',
            'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Falha ao salvar o arquivo de medidor offline',
            'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Falha ao fazer upload do arquivo de anexo',
            'API.FAILED_TO_UPLOAD_COST_FILE': 'Falha ao fazer upload do arquivo de custos',
            'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Falha ao fazer upload do arquivo de reparo de dados',
            'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Falha ao fazer upload do arquivo de conhecimento',
            'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Falha ao fazer upload do arquivo de medidor offline',
            'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'O nome do gateway já está em uso',
            'API.GATEWAY_NOT_FOUND': 'Gateway não encontrado',
            'API.HEAT_METER_NOT_FOUND': 'Medidor de calor não encontrado',
            'API.INVALID_': 'Inválido',
            'API.INVALID_ACKNOWLEDGE_CODE': 'Código de reconhecimento inválido',
            'API.INVALID_ADDRESS': 'Endereço inválido',
            'API.INVALID_ADDRESS_VALUE': 'Valor de endereço inválido',
            'API.INVALID_ADVANCED_REPORT_ID': 'ID de relatório avançado inválido',
            'API.INVALID_API_KEY_ID': 'ID da chave da API inválido',
            'API.INVALID_API_KEY_NAME': 'Nome da chave da API inválido',
            'API.INVALID_AREA_VALUE': 'Valor de área inválido',
            'API.INVALID_BALANCING_PRICE_POINT_ID': 'ID de ponto de preço de equilíbrio inválido',
            'API.INVALID_BASE_PERIOD_END_DATETIME': 'Data e hora de fim do período base inválida',
            'API.INVALID_BASE_PERIOD_START_DATETIME': 'Data e hora de início do período base inválida',
            'API.INVALID_BATTERY_STATE_POINT_ID': 'ID de ponto de estado da bateria inválido',
            'API.INVALID_BAUD_RATE': 'Taxa de bauds inválida',
            'API.INVALID_BUILDINGS_VALUE': 'Valor de edifícios inválido',
            'API.INVALID_BUY_METER_ID': 'ID de medidor de compra inválido',
            'API.INVALID_CAPACITY': 'Capacidade inválida',
            'API.INVALID_CATEGORY': 'Categoria inválida',
            'API.INVALID_CHANNEL': 'Canal inválido',
            'API.INVALID_CHARGE_METER_ID': 'ID de medidor de carga inválido',
            'API.INVALID_COMBINED_EQUIPMENT_ID': 'ID de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Nome de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'ID de parâmetro de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Nome de parâmetro de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Tipo de parâmetro de equipamento combinado inválido',
            'API.INVALID_COMBINED_EQUIPMENT_UUID': 'UUID de equipamento combinado inválido',
            'API.INVALID_COMMAND_ID': 'ID de comando inválido',
            'API.INVALID_COMMAND_NAME': 'Nome de comando inválido',
            'API.INVALID_CONNECTION': 'Conexão inválida',
            'API.INVALID_CONSTANT_VALUE': 'Valor constante inválido',
            'API.INVALID_CONTACT_ID': 'ID de contato inválido',
            'API.INVALID_CONTACT_NAME': 'Nome de contato inválido',
            'API.INVALID_COOLING_METER_ID': 'ID de medidor de resfriamento inválido',
            'API.INVALID_COST_CENTER_ID': 'ID de centro de custo inválido',
            'API.INVALID_COST_FILE_ID': 'ID de arquivo de custos inválido',
            'API.INVALID_CREATED_DATETIME': 'Data e hora de criação inválida',
            'API.INVALID_DATA_REPAIR_FILE_ID': 'ID de arquivo de reparo de dados inválido',
            'API.INVALID_DATA_SOURCE_ID': 'ID de fonte de dados inválido',
            'API.INVALID_DATA_SOURCE_NAME': 'Nome de fonte de dados inválido',
            'API.INVALID_DATA_SOURCE_PROTOCOL': 'Protocolo de fonte de dados inválido',
            'API.INVALID_DATE_LOCAL': 'Local de data inválido',
            'API.INVALID_DENOMINATOR_METER_UUID': 'UUID de medidor de denominador inválido',
            'API.INVALID_DISCHARGE_METER_ID': 'ID de medidor de descarga inválido',
            'API.INVALID_DISPLAY_NAME': 'Nome de exibição inválido',
            'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'ID de circuito de distribuição inválido',
            'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Nome de circuito de distribuição inválido',
            'API.INVALID_DISTRIBUTION_ROOM': 'Sala de distribuição inválida',
            'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'ID de sistema de distribuição inválido',
            'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Nome de sistema de distribuição inválido',
            'API.INVALID_ELECTRICITY_METER_ID': 'ID de medidor de eletricidade inválido',
            'API.INVALID_EMAIL': 'E-mail inválido',
            'API.INVALID_EMAIL_MESSAGE_ID': 'ID de mensagem de e-mail inválido',
            'API.INVALID_EMAIL_SERVER_HOST': 'Host do servidor de e-mail inválido',
            'API.INVALID_EMAIL_SERVER_ID': 'ID de servidor de e-mail inválido',
            'API.INVALID_END_DATE_FORMAT': 'Formato de data final inválido',
            'API.INVALID_END_DATETIME': 'Data e hora de término inválida',
            'API.INVALID_ENERGY_CATEGORY_ID': 'ID de categoria de energia inválido',
            'API.INVALID_ENERGY_CATEGORY_NAME': 'Nome de categoria de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'ID de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'ID de link de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Nome de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'ID de nó de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Nome de nó de diagrama de fluxo de energia inválido',
            'API.INVALID_ENERGY_ITEM_ID': 'ID de item de energia inválido',
            'API.INVALID_ENERGY_ITEM_NAME': 'Nome de item de energia inválido',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'ID de estação de energia de armazenamento inválido',
            'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Nome de estação de energia de armazenamento inválido',
            'API.INVALID_EQUATION_IN_EXPRESSION': 'Equação inválida na expressão',
            'API.INVALID_EQUIPMENT_ID': 'ID de equipamento inválido',
            'API.INVALID_EQUIPMENT_NAME': 'Nome de equipamento inválido',
            'API.INVALID_EQUIPMENT_PARAMETER_ID': 'ID de parâmetro de equipamento inválido',
            'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Nome de parâmetro de equipamento inválido',
            'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Tipo de parâmetro de equipamento inválido',
            'API.INVALID_EQUIPMENT_UUID': 'UUID de equipamento inválido',
            'API.INVALID_EXPIRES_DATETIME': 'Data e hora de expiração inválida',
            'API.INVALID_EXPRESSION': 'Expressão inválida',
            'API.INVALID_EXPRESSION_OBJECT': 'Objeto de expressão inválido',
            'API.INVALID_FDD_CODE': 'Código FDD inválido',
            'API.INVALID_FLOORS_VALUE': 'Valor de andares inválido',
            'API.INVALID_FROM_ADDR': 'Endereço de origem inválido',
            'API.INVALID_GATEWAY_ID': 'ID de gateway inválido',
            'API.INVALID_GATEWAY_NAME': 'Nome de gateway inválido',
            'API.INVALID_HEAT_METER_ID': 'ID de medidor de calor inválido',
            'API.INVALID_HIGH_LIMIT_VALUE': 'Valor de limite superior inválido',
            'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Valor de limite superior horário inválido',
            'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Valor de limite inferior horário inválido',
            'API.INVALID_Id': 'ID inválido',
            'API.INVALID_IS_ADMIN_VALUE': 'Valor de é admin inválido',
            'API.INVALID_IS_COST_DATA_DISPLAYED': 'Valor de exibição de dados de custo inválido',
            'API.INVALID_IS_COUNTED_VALUE': 'Valor de contado inválido',
            'API.INVALID_IS_ENABLED': 'Valor de habilitado inválido',
            'API.INVALID_IS_HIDDEN': 'Valor de oculto inválido',
            'API.INVALID_IS_IN_LEASE_VALUE': 'Valor de está em leasing inválido',
            'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Valor de entrada contado inválido',
            'API.INVALID_IS_KEY_TENANT_VALUE': 'Valor de é inquilino chave inválido',
            'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Valor de saída contado inválido',
            'API.INVALID_IS_OUTPUT_VALUE': 'Valor de saída inválido',
            'API.INVALID_IS_READ_ONLY_VALUE': 'Valor de somente leitura inválido',
            'API.INVALID_IS_TREND_VALUE': 'Valor de tendência inválido',
            'API.INVALID_IS_VIRTUAL_VALUE': 'Valor de virtual inválido',
            'API.INVALID_KGCE': 'KGCE inválido',
            'API.INVALID_KGCO2E': 'KGCO2E inválido',
            'API.INVALID_KNOWLEDGE_FILE_ID': 'ID de arquivo de conhecimento inválido',
            'API.INVALID_LATITUDE_VALUE': 'Valor de latitude inválido',
            'API.INVALID_LEASE_NUMBER_VALUE': 'Valor de número de leasing inválido',
            'API.INVALID_LONGITUDE_VALUE': 'Valor de longitude inválido',
            'API.INVALID_LOW_LIMIT_VALUE': 'Valor de limite inferior inválido',
            'API.INVALID_MASTER_METER_ID': 'ID de medidor mestre inválido',
            'API.INVALID_MENU_ID': 'ID de menu inválido',
            'API.INVALID_MESSAGE_DATA': 'Dados de mensagem inválidos',
            'API.INVALID_MESSAGE_TEMPLATE': 'Modelo de mensagem inválido',
            'API.INVALID_MESSAGE_TEMPLATE_ID': 'ID de modelo de mensagem inválido',
            'API.INVALID_MESSAGE_VALUE': 'Valor de mensagem inválido',
            'API.INVALID_METER_ID': 'ID de medidor inválido',
            'API.INVALID_METER_NAME': 'Nome de medidor inválido',
            'API.INVALID_METER_UUID': 'UUID de medidor inválido',
            'API.INVALID_MICROGRID_BATTERY_ID': 'ID de bateria de microrede inválido',
            'API.INVALID_MICROGRID_BATTERY_NAME': 'Nome de bateria de microrede inválido',
            'API.INVALID_MICROGRID_EVCHARGER_ID': 'ID de carregador EV de microrede inválido',
            'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Nome de carregador EV de microrede inválido',
            'API.INVALID_MICROGRID_GENERATOR_ID': 'ID de gerador de microrede inválido',
            'API.INVALID_MICROGRID_GENERATOR_NAME': 'Nome de gerador de microrede inválido',
            'API.INVALID_MICROGRID_GRID_ID': 'ID de grade de microrede inválido',
            'API.INVALID_MICROGRID_GRID_NAME': 'Nome de grade de microrede inválido',
            'API.INVALID_MICROGRID_HEATPUMP_ID': 'ID de bomba de calor de microrede inválido',
            'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Nome de bomba de calor de microrede inválido',
            'API.INVALID_MICROGRID_ID': 'ID de microrede inválido',
            'API.INVALID_MICROGRID_LOAD_ID': 'ID de carga de microrede inválido',
            'API.INVALID_MICROGRID_LOAD_NAME': 'Nome de carga de microrede inválido',
            'API.INVALID_MICROGRID_NAME': 'Nome de microrede inválido',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'ID de fotovoltaico de microrede inválido',
            'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Nome de fotovoltaico de microrede inválido',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'ID de sistema de conversão de energia de microrede inválido',
            'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Nome de sistema de conversão de energia de microrede inválido',
            'API.INVALID_MICROGRID_UUID': 'UUID de microrede inválido',
            'API.INVALID_NAME_VALUE': 'Valor de nome inválido',
            'API.INVALID_NEW_PASSWORD': 'Nova senha inválida',
            'API.INVALID_NON_WORKING_DAY_ID': 'ID de dia não útil inválido',
            'API.INVALID_NOTIFICATION_ID': 'ID de notificação inválido',
            'API.INVALID_NUMERATOR_METER_UUID': 'UUID de medidor do numerador inválido',
            'API.INVALID_OBJECT_TYPE': 'Tipo de objeto inválido',
            'API.INVALID_OFFLINE_METER_DATA': 'Dados de medidor offline inválidos',
            'API.INVALID_OFFLINE_METER_FILE_ID': 'ID de arquivo de medidor offline inválido',
            'API.INVALID_OFFLINE_METER_ID': 'ID de medidor offline inválido',
            'API.INVALID_OFFLINE_METER_NAME': 'Nome de medidor offline inválido',
            'API.INVALID_OFFLINE_METER_UUID': 'UUID de medidor offline inválido',
            'API.INVALID_OFFSET_CONSTANT_VALUE': 'Valor de constante de deslocamento inválido',
            'API.INVALID_OLD_PASSWORD': 'Senha antiga inválida',
            'API.INVALID_OPENID': 'OpenID inválido',
            'API.INVALID_PARENT_SPACE_ID': 'ID de espaço pai inválido',
            'API.INVALID_PASSWORD': 'Senha inválida',
            'API.INVALID_PAYLOAD': 'Carga útil inválida',
            'API.INVALID_PEAK_CURRENT': 'Corrente de pico inválida',
            'API.INVALID_PEAK_LOAD': 'Carga de pico inválida',
            'API.INVALID_PERIOD_TYPE': 'Tipo de período inválido',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'ID de estação de energia fotovoltaica inválido',
            'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Nome de estação de energia fotovoltaica inválido',
            'API.INVALID_POINT_ID': 'ID de ponto inválido',
            'API.INVALID_POINT_NAME': 'Nome de ponto inválido',
            'API.INVALID_PORT': 'Porta inválida',
            'API.INVALID_POSTAL_CODE_VALUE': 'Valor de código postal inválido',
            'API.INVALID_POWER_POINT_ID': 'ID de ponto de energia inválido',
            'API.INVALID_PRIORITY': 'Prioridade inválida',
            'API.INVALID_PRIVILEGE': 'Privilégio inválido',
            'API.INVALID_PRIVILEGE_DATA': 'Dados de privilégio inválidos',
            'API.INVALID_PRIVILEGE_ID': 'ID de privilégio inválido',
            'API.INVALID_PRIVILEGE_NAME': 'Nome de privilégio inválido',
            'API.INVALID_RATIO_VALUE': 'Valor de razão inválido',
            'API.INVALID_RECIPIENT_EMAIL': 'Email do destinatário inválido',
            'API.INVALID_RECIPIENT_MOBILE': 'Móvel do destinatário inválido',
            'API.INVALID_RECIPIENT_NAME': 'Nome do destinatário inválido',
            'API.INVALID_RECIPIENT_OPENID': 'OpenID do destinatário inválido',
            'API.INVALID_REPLY': 'Resposta inválida',
            'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Data e hora de término do período de relatório inválidos',
            'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Data e hora de início do período de relatório inválidos',
            'API.INVALID_REQUIRES_AUTHENTICATION': 'Requer autenticação inválida',
            'API.INVALID_ROOMS_VALUE': 'Valor de quartos inválido',
            'API.INVALID_RULE_ID': 'ID de regra inválido',
            'API.INVALID_RULE_NAME': 'Nome de regra inválido',
            'API.INVALID_RUN_STATE_POINT_ID': 'ID de ponto de estado de execução inválido',
            'API.INVALID_SCHEDULED_DATETIME': 'Data e hora agendadas inválidas',
            'API.INVALID_SELL_METER_ID': 'ID de medidor de venda inválido',
            'API.INVALID_SENSOR_ID': 'ID de sensor inválido',
            'API.INVALID_SENSOR_NAME': 'Nome de sensor inválido',
            'API.INVALID_SENSOR_UUID': 'UUID de sensor inválido',
            'API.INVALID_SERIAL_NUMBER': 'Número de série inválido',
            'API.INVALID_SERIAL_PORT': 'Porta serial inválida',
            'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Sessão inválida, por favor, faça login novamente',
            'API.INVALID_SET_VALUE': 'Valor de configuração inválido',
            'API.INVALID_SHOPFLOOR_ID': 'ID de andar de loja inválido',
            'API.INVALID_SHOPFLOOR_NAME': 'Nome de andar de loja inválido',
            'API.INVALID_SHOPFLOOR_UUID': 'UUID de andar de loja inválido',
            'API.INVALID_SOURCE_NODE_ID': 'ID de nó de origem inválido',
            'API.INVALID_SPACE_ID': 'ID de espaço inválido',
            'API.INVALID_SPACE_NAME': 'Nome de espaço inválido',
            'API.INVALID_SPACE_UUID': 'UUID de espaço inválido',
            'API.INVALID_START_DATE_FORMAT': 'Formato de data de início inválido',
            'API.INVALID_START_DATETIME': 'Data e hora de início inválidas',
            'API.INVALID_STATUS': 'Status inválido',
            'API.INVALID_STORE_ID': 'ID de loja inválido',
            'API.INVALID_STORE_NAME': 'Nome de loja inválido',
            'API.INVALID_STORE_TYPE_DESCRIPTION': 'Descrição de tipo de loja inválida',
            'API.INVALID_STORE_TYPE_ID': 'ID de tipo de loja inválido',
            'API.INVALID_STORE_TYPE_NAME': 'Nome de tipo de loja inválido',
            'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Código simplificado de tipo de loja inválido',
            'API.INVALID_STORE_UUID': 'UUID de loja inválido',
            'API.INVALID_SUBJECT_VALUE': 'Valor de assunto inválido',
            'API.INVALID_SVG': 'SVG inválido',
            'API.INVALID_SWITCHGEAR': 'Equipamento de manobra inválido',
            'API.INVALID_TARGET_NODE_ID': 'ID de nó de destino inválido',
            'API.INVALID_TARIFF_BLOCK_PRICING': 'Precificação de bloco tarifário inválida',
            'API.INVALID_TARIFF_ID': 'ID de tarifa inválido',
            'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Precificação tarifária por tempo de uso inválida',
            'API.INVALID_TARIFF_TYPE': 'Tipo de tarifa inválido',
            'API.INVALID_TENANT_ID': 'ID de inquilino inválido',
            'API.INVALID_TENANT_NAME': 'Nome de inquilino inválido',
            'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Descrição de tipo de inquilino inválida',
            'API.INVALID_TENANT_TYPE_ID': 'ID de tipo de inquilino inválido',
            'API.INVALID_TENANT_TYPE_NAME': 'Nome de tipo de inquilino inválido',
            'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Código simplificado de tipo de inquilino inválido',
            'API.INVALID_TENANT_UUID': 'UUID de inquilino inválido',
            'API.INVALID_TEXT_MESSAGE_ID': 'ID de mensagem de texto inválido',
            'API.INVALID_TIMEZONE_ID': 'ID de fuso horário inválido',
            'API.INVALID_TOKEN': 'Token inválido',
            'API.INVALID_TOPIC': 'Tópico inválido',
            'API.INVALID_UNIT_OF_MEASURE': 'Unidade de medida inválida',
            'API.INVALID_UNIT_OF_PRICE': 'Unidade de preço inválida',
            'API.INVALID_UNITS': 'Unidades inválidas',
            'API.INVALID_USER_ID': 'ID de usuário inválido',
            'API.INVALID_USER_NAME': 'Nome de usuário inválido',
            'API.INVALID_USER_NAME_OR_EMAIL': 'Nome de usuário ou email inválido',
            'API.INVALID_USER_PHONE': 'Telefone de usuário inválido',
            'API.INVALID_USER_PLEASE_RE_LOGIN': 'Usuário inválido, por favor, faça login novamente',
            'API.INVALID_USER_UUID': 'UUID de usuário inválido',
            'API.INVALID_USERNAME': 'Nome de usuário inválido',
            'API.INVALID_VARIABLE_METER_ID': 'ID de medidor variável inválido',
            'API.INVALID_VARIABLE_METER_TYPE': 'Tipo de medidor variável inválido',
            'API.INVALID_VARIABLE_NAME': 'Nome de variável inválido',
            'API.INVALID_VERIFICATION_CODE': 'Código de verificação inválido',
            'API.INVALID_VIRTUAL_METER_ID': 'ID de medidor virtual inválido',
            'API.INVALID_VIRTUAL_METER_NAME': 'Nome de medidor virtual inválido',
            'API.INVALID_VIRTUAL_METER_UUID': 'UUID de medidor virtual inválido',
            'API.INVALID_WEB_MESSAGE_ID': 'ID de mensagem web inválido',
            'API.INVALID_WECHAT_MESSAGE_ID': 'ID de mensagem WeChat inválido',
            'API.INVALID_WIND_FARM_ID': 'ID de parque eólico inválido',
            'API.INVALID_WIND_FARM_NAME': 'Nome de parque eólico inválido',
            'API.INVALID_WORKING_CALENDAR_ID': 'ID de calendário de trabalho inválido',
            'API.INVALID_WORKING_CALENDAR_NAME': 'Nome de calendário de trabalho inválido',
            'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Arquivo de conhecimento não pode ser removido do disco',
            'API.KNOWLEDGE_FILE_NOT_FOUND': 'Arquivo de conhecimento não encontrado',
            'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': 'O medidor mestre não pertence à mesma categoria de energia',
            'API.MASTER_METER_NOT_FOUND': 'Medidor mestre não encontrado',
            'API.MENU_NOT_FOUND': 'Menu não encontrado',
            'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'O medidor não pode ter mais de um ponto de valor de energia',
            'API.METER_COMMAND_RELATION_EXISTS': 'Relação de comando de medidor existe',
            'API.METER_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de medidor não encontrada',
            'API.METER_NAME_IS_ALREADY_IN_USE': 'Nome do medidor já está em uso',
            'API.METER_NOT_FOUND': 'Medidor não encontrado',
            'API.METER_OF_VARIABLE_NOT_FOUND': 'Medidor de variável não encontrado',
            'API.METER_POINT_RELATION_EXISTS': 'Relação de ponto de medidor existe',
            'API.METER_POINT_RELATION_NOT_FOUND': 'Relação de ponto de medidor não encontrada',
            'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Nome de bateria de microgrid já está em uso',
            'API.MICROGRID_BATTERY_NOT_FOUND': 'Bateria de microgrid não encontrada',
            'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Nome de carregador EV de microgrid já está em uso',
            'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Carregador EV de microgrid não encontrado',
            'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Nome de gerador de microgrid já está em uso',
            'API.MICROGRID_GENERATOR_NOT_FOUND': 'Gerador de microgrid não encontrado',
            'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Nome de rede de microgrid já está em uso',
            'API.MICROGRID_GRID_NOT_FOUND': 'Rede de microgrid não encontrada',
            'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Nome de bomba de calor de microgrid já está em uso',
            'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Bomba de calor de microgrid não encontrada',
            'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Nome de carga de microgrid já está em uso',
            'API.MICROGRID_LOAD_NOT_FOUND': 'Carga de microgrid não encontrada',
            'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Nome de microgrid já está em uso',
            'API.MICROGRID_NOT_FOUND': 'Microgrid não encontrado',
            'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Nome de fotovoltaico de microgrid já está em uso',
            'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Fotovoltaico de microgrid não encontrado',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Nome do sistema de conversão de energia de microgrid já está em uso',
            'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Sistema de conversão de energia de microgrid não encontrado',
            'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Relação de sensor de microgrid existe',
            'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Sensor de microgrid não encontrado',
            'API.MQTT_CONNECTION_ERROR': 'Erro de conexão MQTT',
            'API.MQTT_PUBLISH_ERROR': 'Erro ao publicar no MQTT',
            'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'O comprimento da nova senha não pode exceder 100 caracteres',
            'API.NEW_USER_SESSION_NOT_FOUND': 'Sessão de novo usuário não encontrada',
            'API.NEW_USER_SESSION_TIMEOUT': 'Sessão de novo usuário expirada',
            'API.NON_WORKING_DAY_NOT_FOUND': 'Dia não útil não encontrado',
            'API.NOT_FOUND': 'Não encontrado',
            'API.NOTIFICATION_NOT_FOUND': 'Notificação não encontrada',
            'API.OFFLINE_METER_FILE_NOT_FOUND': 'Arquivo de medidor offline não encontrado',
            'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Nome de medidor offline já está em uso',
            'API.OFFLINE_METER_NOT_FOUND': 'Medidor offline não encontrado',
            'API.INVALID_OFFLINE_METER_VALUE': 'Valor de medidor offline inválido',
            'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Medidor offline de variável não encontrado',
            'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'O comprimento da senha antiga não pode exceder 100 caracteres',
            'API.PARENT_SPACE_NOT_FOUND': 'Espaço pai não encontrado',
            'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'O comprimento da senha não pode exceder 100 caracteres',
            'API.PASSWORDS_MATCH': 'A nova senha é a mesma que a senha antiga',
            'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Nome de estação de energia fotovoltaica já está em uso',
            'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Estação de energia fotovoltaica não encontrada',
            'API.POINT_NAME_IS_ALREADY_IN_USE': 'Nome do ponto já está em uso',
            'API.POINT_NOT_FOUND': 'Ponto não encontrado',
            'API.POWER_POINT_NOT_FOUND': 'Ponto de energia não encontrado',
            'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Nome do privilégio já está em uso',
            'API.PRIVILEGE_NOT_FOUND': 'Privilégio não encontrado',
            'API.RULE_NAME_IS_ALREADY_IN_USE': 'Nome da regra já está em uso',
            'API.RULE_NOT_FOUND': 'Regra não encontrada',
            'API.SELL_METER_NOT_FOUND': 'Medidor de venda não encontrado',
            'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Nome do sensor já está em uso',
            'API.SENSOR_NOT_FOUND': 'Sensor não encontrado',
            'API.SENSOR_POINT_RELATION_EXISTS': 'Relação de ponto de sensor existe',
            'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Relação de ponto de sensor não encontrada',
            'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Relação de comando de shopfloor existe',
            'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de shopfloor não encontrada',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Relação de equipamento de shopfloor existe',
            'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Relação de equipamento de shopfloor não encontrada',
            'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Relação de medidor de shopfloor existe',
            'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Relação de medidor de shopfloor não encontrada',
            'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Nome de shopfloor já está em uso',
            'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor não encontrado',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de shopfloor existe',
            'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de shopfloor não encontrada',
            'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Relação de ponto de shopfloor existe',
            'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Relação de ponto de shopfloor não encontrada',
            'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Relação de sensor de shopfloor existe',
            'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Relação de sensor de shopfloor não encontrada',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de shopfloor existe',
            'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de shopfloor não encontrada',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Relação de calendário de trabalho de shopfloor existe',
            'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relação de calendário de trabalho de shopfloor não encontrada',
            'API.SOC_POINT_NOT_FOUND': 'Ponto SOC não encontrado',
            'API.SOURCE_NODE_NOT_FOUND': 'Nó de origem não encontrado',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Relação de equipamento combinado de espaço existe',
            'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Relação de equipamento combinado de espaço não encontrada',
            'API.SPACE_COMMAND_RELATION_EXISTS': 'Relação de comando de espaço existe',
            'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de espaço não encontrada',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Relação de estação de energia de armazenamento de espaço existe',
            'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Relação de estação de energia de armazenamento de espaço não encontrada',
            'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Relação de equipamento de espaço existe',
            'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Relação de equipamento de espaço não encontrada',
            'API.SPACE_METER_RELATION_EXISTS': 'Relação de medidor de espaço existe',
            'API.SPACE_METER_RELATION_NOT_FOUND': 'Relação de medidor de espaço não encontrada',
            'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Nome de espaço já está em uso',
            'API.SPACE_NOT_FOUND': 'Espaço não encontrado',
            'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Espaço não encontrado no privilégio',
            'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de espaço existe',
            'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de espaço não encontrada',
            'API.SPACE_POINT_RELATION_EXISTS': 'Relação de ponto de espaço existe',
            'API.SPACE_POINT_RELATION_NOT_FOUND': 'Relação de ponto de espaço não encontrada',
            'API.SPACE_SENSOR_RELATION_EXISTS': 'Relação de sensor de espaço existe',
            'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Relação de sensor de espaço não encontrada',
            'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Relação de shopfloor de espaço existe',
            'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Relação de shopfloor de espaço não encontrada',
            'API.SPACE_STORE_RELATION_EXISTS': 'Relação de loja de espaço existe',
            'API.SPACE_STORE_RELATION_NOT_FOUND': 'Relação de loja de espaço não encontrada',
            'API.SPACE_TENANT_RELATION_EXISTS': 'Relação de inquilino de espaço existe',
            'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Relação de inquilino de espaço não encontrada',
            'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de espaço existe',
            'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de espaço não encontrada',
            'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Relação de calendário de trabalho de espaço existe',
            'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relação de calendário de trabalho de espaço não encontrada',
            'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'A data/hora de início deve ser anterior à data/hora de término',
            'API.STORE_COMMAND_RELATION_EXISTS': 'Relação de comando de loja existe',
            'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de loja não encontrada',
            'API.STORE_METER_RELATION_EXISTS': 'Relação de medidor de loja existe',
            'API.STORE_METER_RELATION_NOT_FOUND': 'Relação de medidor de loja não encontrada',
            'API.STORE_NAME_IS_ALREADY_IN_USE': 'Nome de loja já está em uso',
            'API.STORE_NOT_FOUND': 'Loja não encontrada',
            'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de loja existe',
            'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de loja não encontrada',
            'API.STORE_POINT_RELATION_EXISTS': 'Relação de ponto de loja existe',
            'API.STORE_POINT_RELATION_NOT_FOUND': 'Relação de ponto de loja não encontrada',
            'API.STORE_SENSOR_RELATION_EXISTS': 'Relação de sensor de loja existe',
            'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Relação de sensor de loja não encontrada',
            'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Nome do tipo de loja já está em uso',
            'API.STORE_TYPE_NOT_FOUND': 'Tipo de loja não encontrado',
            'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Código simplificado do tipo de loja já está em uso',
            'API.STORE_TYPE_USED_IN_STORE': 'Tipo de loja usado na loja',
            'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de loja existe',
            'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de loja não encontrada',
            'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Relação de calendário de trabalho de loja existe',
            'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relação de calendário de trabalho de loja não encontrada',
            'API.TARGET_NODE_NOT_FOUND': 'Nó de destino não encontrado',
            'API.TARIFF_IN_USE': 'Tarifa em uso',
            'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'A tarifa já está associada ao centro de custo',
            'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'A tarifa não está associada ao centro de custo',
            'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Nome da tarifa já está em uso',
            'API.TARIFF_NOT_FOUND': 'Tarifa não encontrada',
            'API.TENANT_COMMAND_RELATION_EXISTS': 'Relação de comando de inquilino existe',
            'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Relação de comando de inquilino não encontrada',
            'API.TENANT_METER_RELATION_EXISTS': 'Relação de medidor de inquilino existe',
            'API.TENANT_METER_RELATION_NOT_FOUND': 'Relação de medidor de inquilino não encontrada',
            'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Nome de inquilino já está em uso',
            'API.TENANT_NOT_FOUND': 'Inquilino não encontrado',
            'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Relação de medidor offline de inquilino existe',
            'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Relação de medidor offline de inquilino não encontrada',
            'API.TENANT_POINT_RELATION_EXISTS': 'Relação de ponto de inquilino existe',
            'API.TENANT_POINT_RELATION_NOT_FOUND': 'Relação de ponto de inquilino não encontrada',
            'API.TENANT_SENSOR_RELATION_EXISTS': 'Relação de sensor de inquilino existe',
            'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Relação de sensor de inquilino não encontrada',
            'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Nome do tipo de inquilino já está em uso',
            'API.TENANT_TYPE_NOT_FOUND': 'Tipo de inquilino não encontrado',
            'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Código simplificado do tipo de inquilino já está em uso',
            'API.TENANT_TYPE_USED_IN_TENANT': 'Tipo de inquilino usado no inquilino',
            'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Relação de medidor virtual de inquilino existe',
            'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Relação de medidor virtual de inquilino não encontrada',
            'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Relação de calendário de trabalho de inquilino existe',
            'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Relação de calendário de trabalho de inquilino não encontrada',
            'API.TEXT_MESSAGE_NOT_FOUND': 'Mensagem de texto não encontrada',
            'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'O período de relatório deve ser superior a 15 minutos',
            'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Há relação com medidores filhos',
            'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Há relação com espaços filhos',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': 'Há relação com parâmetros de equipamentos combinados',
            'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Há relação com equipamentos combinados',
            'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Há relação com fontes de dados',
            'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'Há relação com links de diagrama de fluxo de energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Há relação com baterias de containers de armazenamento de energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Há relação com redes de containers de armazenamento de energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Há relação com cargas de containers de armazenamento de energia',
            'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Há relação com sistemas de conversão de energia de containers de armazenamento de energia',
            'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Há relação com parâmetros de equipamentos',
            'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Há relação com equipamentos',
            'API.THERE_IS_RELATION_WITH_METER': 'Há relação com medidor',
            'API.THERE_IS_RELATION_WITH_METERS': 'Há relação com medidores',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Há relação com medidor offline',
            'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Há relação com medidores offline',
            'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Há relação com outros medidores virtuais',
            'API.THERE_IS_RELATION_WITH_SENSORS': 'Há relação com sensores',
            'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Há relação com shopfloors',
            'API.THERE_IS_RELATION_WITH_SPACES': 'Há relação com espaços',
            'API.THERE_IS_RELATION_WITH_STORES': 'Há relação com lojas',
            'API.THERE_IS_RELATION_WITH_TENANTS': 'Há relação com inquilinos',
            'API.THERE_IS_RELATION_WITH_USERS': 'Há relação com usuários',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Há relação com medidor virtual',
            'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Há relação com usinas de energia virtuais',
            'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Esta fonte de dados está sendo usada por um medidor',
            'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Este medidor está sendo usado por um medidor virtual',
            'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Este medidor offline está sendo usado por um medidor virtual',
            'API.THIS_SPACE_CANNOT_BE_CLONED': 'Este espaço não pode ser clonado',
            'API.THIS_SPACE_CANNOT_BE_DELETED': 'Este espaço não pode ser deletado',
            'API.TIMEZONE_NOT_FOUND': 'Fuso horário não encontrado',
            'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token não encontrado nos cabeçalhos, por favor faça login',
            'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'A conta do usuário foi bloqueada',
            'API.USER_ACCOUNT_HAS_EXPIRED': 'A conta do usuário expirou',
            'API.USER_ACCOUNT_IS_NOT_LOCKED': 'A conta do usuário não está bloqueada',
            'API.USER_NAME_IS_ALREADY_IN_USE': 'Nome de usuário já está em uso',
            'API.USER_NOT_FOUND': 'Usuário não encontrado',
            'API.USER_PASSWORD_HAS_EXPIRED': 'A senha do usuário expirou',
            'API.USER_PRIVILEGE_NOT_FOUND': 'Privilégio de usuário não encontrado',
            'API.USER_SESSION_NOT_FOUND': 'Sessão de usuário não encontrada',
            'API.USER_SESSION_TIMEOUT': 'Tempo de sessão do usuário expirado',
            'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'UUID do usuário não encontrado nos cabeçalhos, por favor faça login',
            'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Nome de medidor virtual já está em uso',
            'API.VIRTUAL_METER_NOT_FOUND': 'Medidor virtual não encontrado',
            'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Medidor virtual da variável não encontrado',
            'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Ponto virtual deve ser um valor analógico',
            'API.WEB_MESSAGE_NOT_FOUND': 'Mensagem da web não encontrada',
            'API.WECHAT_MESSAGE_NOT_FOUND': 'Mensagem do WeChat não encontrada',
            'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Nome de fazenda eólica já está em uso',
            'API.WIND_FARM_NOT_FOUND': 'Fazenda eólica não encontrada',
            'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Nome do calendário de trabalho já está em uso',
            'API.WORKING_CALENDAR_NOT_FOUND': 'Calendário de trabalho não encontrado',

            MasterMeter: 'Mestre medidor',
            SubMeter: 'Submetro',
            'Power Quality': 'Qualidade de energia',
            'About Power Quality': 'Sobre a qualidade de energia',
            Category: 'Categoria',
            Type: 'Tipo',
            Limit: 'Limite',
            'Normal Limit': 'Limite normal',
            'Severe Limit': 'Limite severo',
            Compliance: 'Taxa de conformidade',
            'Worst Deviation': 'Pior desvio',
            'Worst Time': 'Pior momento',
            'Severe Exceed Count': 'Contagem de excedentes severos',
            'Worst Unbalance': 'Desequilíbrio máximo',
            Hz: 'Hz',
            voltage: 'Tensão',
            current: 'Corrente',
            frequency: 'Frequência',
            voltage_deviation: 'Desvio de tensão',
            current_unbalance: 'Desequilíbrio de corrente',
            voltage_unbalance: 'Desequilíbrio de tensão',
            mean_deviation_pct: 'Desvio médio (%)',
            p95_abs_deviation_pct: 'Desvio absoluto P95 (%)',
            mean_abs_deviation_hz: 'Desvio absoluto médio (Hz)',
            frequency_deviation: 'Desvio de frequência',
            p95_abs_deviation_hz: 'Desvio absoluto P95 (Hz)',
            mean_unbalance_pct: 'Desequilíbrio médio (%)',
            p95_unbalance_pct: 'Desequilíbrio P95 (%)',
            count: 'Contagem',
            min: 'Mín',
            max: 'Máx',
            mean: 'Média',
            std: 'Desvio padrão',
            p5: 'P5',
            p95: 'P95'
        }
};
